export const INTERNAL_WHEE_API_AUTH = process.env.INTERNAL_WHEE_API_AUTH;

export const AIRTABLE_API_KEY = process.env.AIRTABLE_API_KEY;
export const AIRTABLE_BASE_ID = process.env.AIRTABLE_BASE_ID;
export const AIRTABLE_ENDPOINT_URL = process.env.AIRTABLE_ENDPOINT_URL;

export const SANITY_WHEE_API_AUTH = process.env.SANITY_WHEE_API_AUTH;

export const NEXT_PUBLIC_URL = process.env.NEXT_PUBLIC_URL;

export const LONG_BIKE_SLUG_ORDER = process.env.LONG_BIKE_SLUG_ORDER;
